export default __webpack_public_path__ + "static/media/logo-ayyildiz-horizontal157.a65e3b3e.png";